import cn from 'classnames';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {DualLayout} from '../../../components/DataDisplay';
import DevicePrimaryColorContainer from '../../../components/Device/DevicePrimaryColorContainer';
import {PopupFullPage} from '../../../components/Popup';
import SkipRegistrationButton from '../../../components/SkipRegistrationButton/SkipRegistrationButton';
import appConfig from '../../../config/appConfig';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {amplitudeRegistrationTracking} from '../../../services/amplitude';
import analyticsService from '../../../services/analyticsService';
import deviceTypesService from '../../../services/device/deviceTypesService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';
import pairingService from '../../../services/pairingService';
import productService from '../../../services/product/productService';
import {selectIotDeviceType, selectProductName} from '../../../state/selectors/iotDevice';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import DeviceImageConnected from '../../DeviceImage/DeviceImageConnected';

const OutsideRegistrationPopup = ({modalType}) => {
    const productName = useSelector(selectProductName);
    const deviceType = useSelector(selectIotDeviceType);
    const productRegistrationUrl = appConfig.getProductRegistrationUrlFormatted();
    const isP4 = deviceTypesService.isP4(deviceType);
    const isSkipRegistrationEnabled = productService.isSkipRegistrationEnabled(isP4);
    const localizedStrings = getLocalizedStrings();
    const titleText = localizedStrings.formatString(
        localizedStrings[localizationKeys.DEVICE_CONNECTION_TO_IOT_DEVICE_OUTSIDE_REGISTRATION_TITLE],
        productName
    );

    const onCancelClick = () => {
        pairingService.disconnectAndForwardToMyDevicesPage();
        modalService.hideModal(modalType);
    };

    useEffect(() => {
        analyticsService.pushRegistrationNonNativeEvent(deviceType);
    }, []);

    const onSkipRegClick = () => {
        modalService.hideModal(modalType);
    };
    const btnNotNow = isSkipRegistrationEnabled
        ? undefined
        : {
              onClick: onCancelClick,
              testId: elementsTesIds.DEVICE_REGISTRATION_BTN_SKIP,
              className: 'w-full mt-0 md:max-w-[312px]',
              textKey: localizationKeys.DEVICE_CONNECTION_TO_IOT_NOT_NOW_BUTTON,
          };

    return (
        <PopupFullPage contentLabel={titleText}>
            <DualLayout
                className='lg:py-36'
                articleProps={{
                    titleText,
                    titleClassName: 'mt-8 mb-3 lg:mt-0 lg:mb-2',
                    descriptionKey: localizationKeys.DEVICE_CONNECTION_TO_IOT_DEVICE_OUTSIDE_REGISTRATION_DESCRIPTION,
                    buttonsDirection: 'column',
                    descriptionClassName: 'lg:-mb-5',
                    className: 'lg:items-start',
                    buttonPrimary: {
                        to: productRegistrationUrl,
                        isExternalLink: true,
                        className: cn('w-full md:max-w-[312px]', {'mt-0': !isSkipRegistrationEnabled}),
                        textKey: localizationKeys.DEVICE_CONNECTION_TO_IOT_REGISTER_BUTTON,
                        testId: elementsTesIds.DEVICE_REGISTRATION_BTN_EXTERNAL_REG,
                        onClick: () => {
                            amplitudeRegistrationTracking.trackRegistrationStarted();
                        },
                    },
                    buttonSecondary: btnNotNow,
                    children: (
                        <SkipRegistrationButton onSkipClick={onSkipRegClick} className='w-full md:max-w-[312px]' />
                    ),
                }}
            >
                <DevicePrimaryColorContainer
                    isBackgroundImageEnabled
                    className='relative flex h-[212px] w-full items-center justify-center md:h-[420px] lg:h-[540px]'
                >
                    <DeviceImageConnected className='h-[180px] w-[180px] md:h-[360px] md:w-[360px]' />
                </DevicePrimaryColorContainer>
            </DualLayout>
        </PopupFullPage>
    );
};

export default OutsideRegistrationPopup;
